export const APP_SERVICE_MUTATION_KEYS = {
	SUBMIT_ATTACHMENTS: ['submitAttachments'],
};
